import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { AdressesService, Adresse, AdressePayload, AdresseType } from '../../../../services/adresses.service';
import { ClientsService, Client } from '../../../../services/clients.service';
import {ChangeDetectorRef} from '@angular/core';

@Component({
  selector: 'app-adresses-list',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './adresses.component.html',
  styleUrl: './adresses.component.scss'
})
export class AdressesListComponent implements OnInit {
  adresses: Adresse[] = [];
  clients: Client[] = [];
  selectedClientId: number | '' = '';
  error = '';
  success = '';
  loading = false;
  loadingList = false;
  deletingId: number | null = null;

  constructor(
    private readonly adressesService: AdressesService,
    private readonly clientsService: ClientsService,
    private readonly cdr: ChangeDetectorRef,
    private readonly router: Router
  ) {}


  ngOnInit(): void {
    // Charge d'abord les clients, puis les adresses
    this.clientsService.list().subscribe((clients) => {
      this.clients = clients;
      this.cdr.detectChanges();
      this.loadAdresses();
    });
  }

  loadAdresses(): void {
    this.loadingList = true;
    this.adressesService.list().subscribe({
      next: (adresses) => {
        this.adresses = adresses;
        this.loadingList = false;
        this.cdr.detectChanges();
      },
      error: () => {
        this.error = 'Erreur lors du chargement des adresses';
        this.loadingList = false;
      }
    });
  }

  selectAdresse(id: number): void {
    this.router.navigate(['/intranet/gestion-logistiques/adresses/modifier'], { queryParams: { id } });
  }
  get filteredAdresses(): Adresse[] {
    if (!this.selectedClientId) return this.adresses;
    const selectedIdNum = typeof this.selectedClientId === 'string' ? parseInt(this.selectedClientId as string, 10) : this.selectedClientId;
    return this.adresses.filter(a => a.client_id === selectedIdNum);
  }



  
  deleteAdresse(id: number): void {
    if (!confirm('Supprimer cette adresse ?')) return;
    this.deletingId = id;
    this.adressesService.delete(id).subscribe({
      next: () => {
        this.success = 'Adresse supprimée.';
        this.loadAdresses();
        this.deletingId = null;
      },
      error: () => {
        this.error = 'Erreur lors de la suppression.';
        this.deletingId = null;
      }
    });
  }
}
